export var MuiListItem = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        "& span": {
          marginRight: "".concat(theme.spacing(theme.spaces.small), " !important")
        }
      };
    }
  }
};
//# sourceMappingURL=MuiListItem.js.map